import React, { useEffect, useState } from "react";
import { Modal, Icon, Button, message, Tag, Input, Checkbox, Select, Popover, Alert, Cascader, DatePicker, Tree } from "antd";
import { useWatchState, usePage, useService, useModal } from "@/store";
import { BaseService } from "@/service";
import { checkResult, createSelectOption, loadRegions } from "@/common";
import { TouchContainer } from "@/container";
import { isNullObject } from "@/check";
import { arr2Dic, deepCopy } from "@/utils";
import "./style.less";

const closeWarn = localStorage.getItem("closeOrgWarn") || false;
const closeShowOrgWarn = () => localStorage.setItem("closeOrgWarn", "1");

const { Search, TextArea } = Input;
const { TreeNode } = Tree;

const NAME = "pushSelectOrg";

const View = () => {

    const [[REGIONS = []]] = useWatchState(["$_REGIONS"]);
    const [[ORG_GROUPS_DETAIL = []]] = useWatchState(["$_ORG_GROUPS_DETAIL"]);
    const [[DEMAND_ACTIVITY_TYPE = []]] = useWatchState(["$_DEMAND_ACTIVITY_TYPE"]);
    const [[SCOPE = []]] = useWatchState(["$_SCOPE"]);
    const [[INDUSTRY = []]] = useWatchState(["$_INDUSTRY"]);

    const [pushTimeModal] = useModal(["pushTime"]);

    const [[props]] = useWatchState(["modal." + NAME])
    const { title = "推送配置", show, hide, type, state, callback, defaultItems, targetPushTitle, targetPushTitleParams, targetPushRemark, pushGroupId, pushWechatId, autoPushTime } = props;
    const name = { result: "成果", demand: "需求" }[type]
    const table = { result: "thtt_chengguo", demand: "thtt_xuqiu" }[type]
    const key = { result: "chengguo_id", demand: "xuqiu_id" }[type]

    const [pushTitle, setPushTitle] = useState();
    const [pushTitleParams, setPushTitleParams] = useState();
    const [pushTime, setPushTime] = useState();
    const [titleParams, setTitleParams] = useState({
        source: [],
        date: "",
        scopes: [],
        activity: { label: "", key: "" },
    });

    const setTitleParamsHandler = (field, e) => {
        titleParams[field] = e;
        setTitleParams({ ...titleParams });
    }
    useEffect(() => {
        const { source, scopes, date, activity } = titleParams;
        setPushTitleParams(`${(scopes && scopes.label) ? "（" + scopes.label + "）" : ""}${source && source.map(({ label }) => label).join("")} ${date ? date.format("YYYY年MM月DD日") : ""}${(activity && activity.label) ? " - " + activity.label : ""}`)
    }, [titleParams])

    const [pushReamrk, setPushReamrk] = useState();
    const [itemScope, setItemScope] = useState();
    const [orgScope, setOrgScope] = useState();
    const [itemIndustry, setItemIndustry] = useState();
    const [orgIndustry, setOrgIndustry] = useState();
    const [keyword, setKeyword] = useState(0);
    const [orgKeyword, setOrgKeyword] = useState(0);
    const [selectAll, setSelectAll] = useState(false);
    useEffect(() => {
        if (selectAll) {
            items.map(({ item_id, name, push_wechat_ids }) => {
                selected.items[item_id] = { name, push_wechat_ids }
            })
        } else {
            selected.items = {};
        }
        setSelected({ ...selected });
    }, [selectAll])

    const [selected, setSelected] = useState({
        items: {},
        orgs: {},
        orgsGroup: {},
    })

    // 白名单（修改时，属于预推送列表的是可以编辑的）
    const [whiteList, setWhiteList] = useState([]);

    const clear = () => {
        setSelected({
            items: {},
            orgs: {},
            orgsGroup: {},
        });
    }

    const [items = [], itemsControl] = usePage({
        atonce: false,
        cache: true,
        service: BaseService.list,
        size: 20,
        params: {
            table: "thtt_push_group_items",
            leftJoin: [
                {
                    table,
                    on: `thtt_push_group_items.item_id = ${table}.${key}`,
                    columns: ["name", "profile"]
                },
                {
                    table: "thtt_organization",
                    on: `thtt_organization.organization_id = ${table}.unit`,
                    columns: ["profile AS orgProfile"]
                },
                ...(itemScope && itemScope.length ? [{
                    table: `${table}_scope`,
                    on: `${table}.${key} = ${table}_scope.${key}`,
                    columns: ["first_scope_id"]
                }] : []),
            ],
            where: [
                { push_group_id: pushGroupId, "thtt_push_group_items.push_state": 0 },
                ...((itemScope && itemScope.length) || (itemIndustry && itemIndustry.length) ? ["AND"] : []),
                ...((itemScope && itemScope.length) ? [{ [`${table}_scope.first_scope_id`]: itemScope.map(({ key }) => key) }] : []),
                ...((itemIndustry && itemIndustry.length) ? [{
                    [`${table}.industry_id`]: {
                        condition: "LIKE",
                        value: JSON.stringify(itemIndustry.map(({ key }) => key))
                    }
                }] : []),
                ...(keyword ? ["AND", {
                    [`${table}.name`]: {
                        value: keyword,
                        condition: "LIKE"
                    }
                }] : []),
            ],
            process: {
                name: "scopes",
                key: "item_id",
                targetKey: key,
                params: {
                    table: table + "_scope",
                    columns: "second_scope_id",
                    leftJoin: {
                        table: "thtt_scope",
                        on: table + "_scope.second_scope_id = thtt_scope.id",
                        columns: JSON.stringify(["name AS scopeName"])
                    }
                }
            },
            order: JSON.stringify([table + ".add_time DESC"])
        },
        format: res => res.data.result.records
    })
    const [orgs = [], orgsControl] = usePage({
        atonce: false,
        cache: true,
        service: BaseService.list,
        size: 20,
        params: {
            table: "thtt_organization",
            columns: "organization_id,name,contacts,contacts_tel,profile,user_id",
            where: [
                { [`thtt_organization.is_delete`]: 0 },
                ...((orgScope && orgScope.length) || (orgIndustry && orgIndustry.length) ? ["AND"] : []),
                ...((orgScope && orgScope.length) ? [{ "thtt_organization_scope.first_scope_id": JSON.stringify(orgScope.map(({ key }) => key)) }] : []),
                ...((orgIndustry && orgIndustry.length) ? [{
                    "thtt_organization.industry_id": {
                        condition: "LIKE",
                        value: JSON.stringify(orgIndustry.map(({ key }) => key))
                    }
                }] : []),
                ...(orgKeyword ? ["AND", {
                    "thtt_organization.name": {
                        value: orgKeyword,
                        condition: "LIKE"
                    }
                }] : []),
            ],
            leftJoin: JSON.stringify([
                {
                    table: "thtt_user",
                    on: "thtt_organization.user_id = thtt_user.user_id",
                    columns: JSON.stringify(["name AS adminUserName", "tel AS adminUserTel", "openid"])
                },
                ...((orgScope && orgScope.length) ? [{
                    table: "thtt_organization_scope",
                    on: "thtt_organization.organization_id = thtt_organization_scope.org_id",
                    columns: JSON.stringify(["first_scope_id"])
                }] : [])
            ]),
            order: JSON.stringify(["thtt_organization.add_time DESC"])
        },
        format: res => res.data.result.records
    })

    useEffect(() => {
        if (pushGroupId && show) {
            clear();
            itemsControl.clear();
            itemsControl.go(1);
            orgsControl.go(1);

            if (targetPushTitle) setPushTitle(targetPushTitle);
            if (targetPushTitleParams) setPushTitleParams(targetPushTitleParams);
            if (targetPushRemark) setPushReamrk(targetPushRemark);
            if (autoPushTime) setPushTime(new Date(autoPushTime * 1000));
        }
    }, [pushGroupId])

    useEffect(() => {
        if (defaultItems && state === "add") {
            selected.items = arr2Dic(defaultItems, "item_id");
            setSelected({ ...selected })
        }
    }, [defaultItems])

    const getSelected = push_id => {
        BaseService.list({
            table: "thtt_push_wechat_orgs",
            leftJoin: {
                table: "thtt_organization",
                on: `thtt_organization.organization_id = thtt_push_wechat_orgs.org_id`,
                columns: JSON.stringify(["name"])
            },
            where: { push_id }
        }).then(res => {
            if (!checkResult(res)) return;
            let orgs = {};
            res.data.result.forEach(({ org_id, name }) => orgs[org_id] = ({ name }));
            selected.orgs = orgs;
            setSelected({ ...selected });
        })
        BaseService.list({
            table: "thtt_push_group_items",
            leftJoin: {
                table,
                on: `${table}.${key} = thtt_push_group_items.item_id`,
                columns: JSON.stringify(["name"])
            },
            where: { push_wechat_ids: pushWechatId }
        }).then(res => {
            if (!checkResult(res)) return;
            let items = {};
            res.data.result.forEach(({ item_id, name, push_group_id }) => items[item_id] = ({ name, push_group_id }));
            selected.items = items;
            setSelected({ ...selected });
            setWhiteList(Object.keys(items))
        })
    }

    useEffect(() => {
        setWhiteList([]);
        if (pushWechatId && show) {
            getSelected(pushWechatId)
        }
    }, [pushWechatId])

    useEffect(() => {
        if (show && table) {
            itemsControl.clear();
            itemsControl.go(1);
        }
    }, [itemScope, itemIndustry, keyword])

    useEffect(() => {
        if (orgScope || orgIndustry || orgKeyword !== undefined) {
            orgsControl.clear();
            orgsControl.go(1);
        }
    }, [orgScope, orgIndustry, orgKeyword])

    const add = async orgGroup => {
        console.log("add handler")
        if (!pushTitle) return message.warn("请设置推送标题");
        if (!pushReamrk) return message.warn("请设置推送备注");
        if (isNullObject(selected.items)) return message.warn("请选择要推送的" + name);
        if (isNullObject(selected.orgs) && isNullObject(selected.orgsGroup)) return message.warn("请选择要推送的机构");
        const item_type = { result: 1, demand: 2 }[type];
        const res = await BaseService.add({
            table: "thtt_push_wechat",
            data: {
                title: pushTitle,
                title_params: pushTitleParams,
                push_group_id: pushGroupId,
                remark: pushReamrk,
                push_status: 0,
                item_type,
                add_time: new Date().format("yyyy-MM-dd hh:mm:ss"),
                auto_push_time: pushTime && Math.floor(pushTime.getTime() / 1000)
            }
        });
        if (!checkResult(res)) return;
        const push_id = res.data.result.id;

        await BaseService.put({
            table: "thtt_push_group_items",
            data: { push_state: 1, push_wechat_ids: push_id },
            where: { push_group_id: pushGroupId, item_id: JSON.stringify(Object.keys(selected.items)) }
        })
        await BaseService.adds({
            table: "thtt_push_wechat_orgs",
            data: JSON.stringify(Object.keys(selected.orgs).map(org_id => ({ push_id, org_id, push_group_id: pushGroupId })))
        })
        if (callback) callback();
        hide();
    }

    const put = async (orgGroup) => {
        await BaseService.put({
            table: "thtt_push_wechat",
            data: {
                title: pushTitle,
                remark: pushReamrk,
                title_params: pushTitleParams,
                auto_push_time: pushTime && Math.floor(pushTime.getTime() / 1000)
            },
            where: { id: pushWechatId }
        })
        const delRes = await BaseService.remove({
            table: "thtt_push_wechat_orgs",
            where: { push_id: pushWechatId }
        })

        if (!checkResult(delRes)) return;
        BaseService.adds({
            table: "thtt_push_wechat_orgs",
            data: JSON.stringify(Object.keys(selected.orgs).map(org_id => ({ push_id: pushWechatId, org_id, push_group_id: pushGroupId })))
        })

        const item_id = JSON.stringify(Object.keys(selected.items).map(item_id => item_id));

        await BaseService.put({
            table: "thtt_push_group_items",
            data: {
                push_wechat_ids: "",
                push_state: 0
            },
            where: { push_wechat_ids: pushWechatId }
        }).then(delRes => {
            if (!checkResult(delRes)) return;
            BaseService.put({
                table: "thtt_push_group_items",
                data: {
                    push_wechat_ids: pushWechatId,
                    push_state: 1
                },
                where: { item_id, push_group_id: pushGroupId }
            })
        })
        if (callback) callback();
        hide();
    }

    const finish = async () => {

        // 格式化机构组数据
        var orgGroup = {};
        if (!isNullObject(selected.orgsGroup)) {
            Object.values(selected.orgsGroup).forEach(vo => {
                if (!orgGroup[vo.pid]) orgGroup[vo.pid] = [];
                orgGroup[vo.pid].push(vo)
            })
        }

        ({ add, put }[state])(orgGroup);
    }
    // 删除已选的成果/需求
    const onCloseItemTag = key => {
        delete selected.items[key]
        setSelected({ ...selected });
    }
    // 删除已选的成果/需求
    const onCloseOrgTag = (key) => {
        delete selected.orgs[key]
        setSelected({ ...selected });
    }
    const onCloseOrgGroupTag = (key) => {
        delete selected.orgsGroup[key]
        setSelected({ ...selected });
    }
    // 关键字搜索
    const onSearchItem = key => {
        setKeyword(key);
    }
    const onSearchOrg = key => {
        console.log(orgsControl.params.where);
        setOrgKeyword(key);
        // if (key) {
        //     orgsControl.params.where.name = {
        //         value: key,
        //         condition: "LIKE"
        //     }
        // } else delete orgsControl.params.where.name
        // orgsControl.go(1);
    }
    const onChangeItemSelected = (id, name, push_wechat_ids, e) => {
        if (e.target.checked) selected.items[id] = { name, push_wechat_ids };
        else delete selected.items[id];
        setSelected({ ...selected });
    }
    const onChangeOrgSelected = (id, name, e) => {
        if (e.target.checked) selected.orgs[id] = ({ name });
        else delete selected.orgs[id];
        setSelected({ ...selected });
    }

    const renderTreeNodes = (data, keyName = "id") =>
        data.map(item => {
            if (item.items) {
                return (
                    <TreeNode title={item.name + `（${item.items.length}个机构）`} key={item[keyName]} dataRef={item}>
                        {renderTreeNodes(item.items, "org_id")}
                    </TreeNode>
                );
            }

            return <TreeNode disabled={!item.openid} key={item[keyName]} title={item.name} {...item} pid={item.id} />;
        });

    const onCheckedOrgGroup = (...arg) => {
        const [items, group] = arg;
        const checkedOrg = group.checkedNodes.filter(({ props }) => !props.children).map(({ key, props }) => ({ org_id: key, name: props.title, org_group_id: props.pid }));
        selected.orgs = arr2Dic(checkedOrg, "org_id");
        setSelected({ ...deepCopy(selected) })
    }

    const onSelectPushTime = time => {
        setPushTime(time)
    }

    return (
        <Modal
            title={title}
            visible={show}
            width="80vw"
            maskClosable={false}
            onCancel={hide}
            footer={(
                <div className="flex row-end child-left-sm">
                    <Button type="primary" icon="calendar" onClick={pushTimeModal.show.later({ defaultTime: pushTime, callback: onSelectPushTime })}>定时推送 {Boolean(pushTime) && pushTime.format("yyyy-MM-dd hh:mm:ss")}</Button>
                    <Button type="primary" onClick={finish}>保存</Button>
                    <Button onClick={hide}>取消</Button>
                </div>
            )}
        >
            <div className="child-top-sm">
                <div className="flex child-left-sm child-full">
                    <Input value={pushTitleParams} disabled={true} maxLength={100} placeholder="推送主题" />
                    <Input value={pushTitle} onChange={e => setPushTitle(e.target.value)} maxLength={100} placeholder="推送主题" />
                </div>
                <div className="child-left-sm">
                    <Cascader
                        options={REGIONS}
                        changeOnSelect
                        loadData={loadRegions}
                        onChange={(e, o) => setTitleParamsHandler("source", o)}
                        className={titleParams.source.length && "mockInput"}
                        placeholder={titleParams.source.length ? titleParams.source.map(({ label }) => label).join(" / ") : '请选择需求来源！'}
                    />
                    <DatePicker onChange={setTitleParamsHandler.later("date")} />
                    <Select style={{ minWidth: "150px" }} onChange={setTitleParamsHandler.later("scopes")} placeholder="请选择领域" mode="multiple" labelInValue>
                        {createSelectOption(SCOPE)}
                    </Select>
                    <Select style={{ minWidth: "150px" }} onChange={setTitleParamsHandler.later("activity")} placeholder="请选择活动类型" labelInValue>
                        {createSelectOption(DEMAND_ACTIVITY_TYPE)}
                    </Select>
                </div>
                <TextArea className="self-top-sm" value={pushReamrk} onChange={e => setPushReamrk(e.target.value)} maxLength={200} placeholder="推送主题说明" />
                <div className="m-push flex child-full child-left-sm self-top-sm">

                    {/* 成果需求列表 */}
                    <div className="child-top-sm">
                        {/* 已选的成果 ｜ 需求 */}
                        <p className="bold">已打包需求</p>
                        <div className="over-auto border p-sm radius-5" style={{ height: "10vh", minHeight: "80px" }}>
                            {isNullObject(selected.items) ? <p className="dark-disable">已选{name}</p> : Object.entries(selected.items).map(([key, vo]) => (
                                <Tag closable onClose={onCloseItemTag.later(key)}>{vo.name}</Tag>
                            ))}
                        </div>
                        {/* 待选列表 */}
                        <div className="child-top-sm">
                            <div className="flex child-left-sm">
                                <Search onSearch={onSearchItem} />
                                <Select style={{ minWidth: "150px" }} onChange={setItemScope} placeholder="请选择领域" mode="multiple" labelInValue>
                                    {createSelectOption(SCOPE)}
                                </Select>
                                <Select style={{ minWidth: "150px" }} onChange={setItemIndustry} placeholder="请选择行业" mode="multiple" labelInValue>
                                    {createSelectOption(INDUSTRY)}
                                </Select>
                            </div>
                            <div>
                                <Button onClick={setSelectAll.later(!selectAll)}>{selectAll ? "取消全选" : "全选"}</Button>
                            </div>
                            <TouchContainer onScrollBottom={itemsControl.next} className="border-b child-border-t over-auto" style={{ height: "40vh" }}>
                                {items.map(vo => (
                                    <div className="p-sm flex between child-left-md">
                                        <Checkbox
                                            style={{ width: "60%" }}
                                            className="nowrap--ellipsis"
                                            disabled={!whiteList.includes(vo.item_id) && vo.push_state}
                                            checked={vo.item_id && selected.items[vo.item_id]}
                                            onChange={onChangeItemSelected.later(vo.item_id, vo.name, vo.push_wechat_ids)}
                                        >
                                            {vo.name}
                                        </Checkbox>
                                        <div style={{ width: "40%" }} className="font-size-12 nowrap--ellipsis">{vo.scopes.map(({ scopeName }) => scopeName).join(" ") || "-"}</div>
                                        <Popover content={(
                                            <div className="child-top-sm" style={{ width: "300px" }}>
                                                <div className="flex child-left-md">
                                                    <p className="child-left--mini"><Icon type="user" /><span>{vo.contacts}</span></p>
                                                    <p className="child-left--mini"><Icon type="phone" /><span>{vo.contacts_tel}</span></p>
                                                </div>
                                                <p className="font-size-18 bold">{name}简介</p>
                                                <div className="over-auto" style={{ maxHeight: "300px" }} dangerouslySetInnerHTML={{ __html: vo.profile }} />
                                                <p className="font-size-18 bold">机构简介</p>
                                                <div className="over-auto" style={{ maxHeight: "300px" }} dangerouslySetInnerHTML={{ __html: vo.orgProfile }} />
                                            </div>
                                        )} title={vo.name} trigger="click">
                                            <Icon type="info-circle" />
                                        </Popover>
                                    </div>
                                ))}
                            </TouchContainer>
                        </div>
                    </div>

                    {/* 机构列表 */}
                    <div className="child-top-sm">
                        {/* 已选的机构 */}
                        <p className="bold">已选择机构</p>
                        <div className="over-auto border p-sm radius-5" style={{ height: "10vh", minHeight: "80px" }}>
                            {isNullObject(selected.orgs) && isNullObject(selected.orgsGroup) ? <p className="dark-disable">已选机构</p> : (
                                <div>
                                    {Object.entries(selected.orgsGroup).map(([key, { name }]) => (
                                        <Tag closable onClose={onCloseOrgGroupTag.later(key)}>{name}</Tag>
                                    ))}
                                    {Object.entries(selected.orgs).map(([key, { name }]) => (
                                        <Tag closable onClose={onCloseOrgTag.later(key)}>{name}</Tag>
                                    ))}
                                </div>
                            )}
                        </div>
                        {/* 待选列表 */}
                        <div className="child-top-sm">
                            <div className="flex child-left-sm">
                                <Search onSearch={onSearchOrg} />
                                <Select style={{ minWidth: "150px" }} onChange={setOrgScope} placeholder="请选择领域" mode="multiple" labelInValue>
                                    {createSelectOption(SCOPE)}
                                </Select>
                                <Select style={{ minWidth: "150px" }} onChange={setOrgIndustry} placeholder="请选择行业" mode="multiple" labelInValue>
                                    {createSelectOption(INDUSTRY)}
                                </Select>
                            </div>
                            {!closeWarn && <Alert
                                message="只能选择已经设置了管理员，且管理员绑定了微信的机构"
                                type="warning"
                                closable
                                onClose={closeShowOrgWarn}
                            />}
                            <TouchContainer onScrollBottom={orgsControl.next} className="border-b child-border-t over-auto" style={{ height: "40vh" }}>
                                <p className="bold">机构群组</p>
                                <Tree
                                    checkable
                                    onCheck={onCheckedOrgGroup}
                                    checkedKeys={Object.keys(selected.orgs)}
                                >
                                    {renderTreeNodes(ORG_GROUPS_DETAIL)}
                                </Tree>
                                {/* // <div className="">
                                    //     <Checkbox
                                    //         style={{ width: "60%" }}
                                    //         className="nowrap--ellipsis p-sm"
                                    //         checked={selected.orgsGroup[id]}
                                    //         onChange={onChangeGroupSelected.later(id, name, items)}
                                    //     >
                                    //         {name}（共{items.length}家机构）
                                    //     </Checkbox>
                                    //     <div className="border-left flex col p-md-l m-sm-l">
                                    //         {items.map(({ name, org_id }) => (
                                    //             <Checkbox
                                    //                 style={{ width: "60%" }}
                                    //                 style={{ marginLeft: 0 }}
                                    //                 className="nowrap--ellipsis p-sm"
                                    //                 checked={selected.orgsGroup[org_id]}
                                    //                 onChange={onChangeOrgSelected.later(org_id, name)}
                                    //             >
                                    //                 {name}
                                    //             </Checkbox>
                                    //         ))}
                                    //     </div>
                                    // </div> */}
                                <p className="bold m-md-t">单个机构</p>
                                {orgs.map(vo => (
                                    <div className="p-sm flex between child-left-sm">
                                        <Checkbox disabled={!vo.user_id || !vo.openid} checked={selected.orgs[vo.organization_id]} onChange={onChangeOrgSelected.later(vo.organization_id, vo.name)}>{vo.openid && <Icon type="wechat" style={{ color: "#65b257" }} />} {vo.name}</Checkbox>
                                        <Popover content={(
                                            <div className="child-top-sm" style={{ width: "300px" }}>
                                                <div className="flex child-left-md">
                                                    <p className="child-left--mini"><Icon type="user" />
                                                        {/* <span>{vo.contacts}</span> */}
                                                        {/* <span>{vo.openid ? <Icon type="wechat" style={{ color: "#65b257" }} /> : ""}</span> */}
                                                        <span>{vo.adminUserName}</span>
                                                    </p>
                                                    <p className="child-left--mini"><Icon type="phone" /><span>{vo.adminUserTel}</span></p>
                                                </div>
                                                <p className="font-size-18 bold">机构简介</p>
                                                <div className="over-auto" style={{ maxHeight: "300px" }} dangerouslySetInnerHTML={{ __html: vo.profile }} />
                                            </div>
                                        )} title={vo.name} trigger="click">
                                            <Icon type="info-circle" />
                                        </Popover>
                                        {/* <Dropdown overlay={menu}>
                                    <Icon type="setting" />
                                    </Dropdown> */}
                                    </div>
                                ))}
                            </TouchContainer>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default View;